'use client';
import React, { FC, Fragment } from 'react';
import { TabContentConfig } from '~/definitions/tab';

interface Props {
    tabContent: TabContentConfig[];
}

const TabContent: FC<Props> = (props) => {
    return (
        <div className="responsive-main-container w-full ml-auto mr-auto container main-content text-[82%] pb-[100px]">
            {props.tabContent.map((tab) => (
                <Fragment key={tab.name}>{tab.content}</Fragment>
            ))}
        </div>
    );
};

export default TabContent;
